export default __webpack_public_path__ + "static/media/Search_alt.6e4f7bc6.svg";